/**
 * StatusToggle Component
 * Componente reutilizável para exibir e alternar status (Ativo/Inativo)
 * O próprio componente de status é clicável para ativar/desativar
 */

import React from 'react';
import { Chip, ChipProps } from '@mui/material';

export interface StatusToggleProps extends Omit<ChipProps, 'onClick' | 'label' | 'color'> {
  isActive: boolean;
  activeLabel?: string;
  inactiveLabel?: string;
  activeColor?: 'success' | 'primary' | 'secondary' | 'error' | 'info' | 'warning';
  inactiveColor?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'warning';
  onClick: (isActive: boolean) => void;
  disabled?: boolean;
}

export const StatusToggle: React.FC<StatusToggleProps> = ({
  isActive,
  activeLabel = 'Ativo',
  inactiveLabel = 'Inativo',
  activeColor = 'success',
  inactiveColor = 'default',
  onClick,
  disabled = false,
  size = 'small',
  ...chipProps
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick(isActive);
    }
  };

  return (
    <Chip
      label={isActive ? activeLabel : inactiveLabel}
      color={isActive ? activeColor : inactiveColor}
      size={size}
      onClick={handleClick}
      disabled={disabled}
      sx={{
        cursor: disabled ? 'default' : 'pointer',
        '&:hover': disabled
          ? {}
          : {
              opacity: 0.8,
              transform: 'scale(1.05)',
              transition: 'all 0.2s ease-in-out'
            },
        ...chipProps.sx
      }}
      {...chipProps}
    />
  );
};

export default StatusToggle;
